import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as PaymentCard } from 'assets/images/payment-card-default.svg';

export const MenuItem: any = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 14px 16px;
  border-bottom: 1px solid ${ColorPalette.HEX.AntiFlashWhite4};
  cursor: pointer;

  &:active {
    background-color: ${ColorPalette.HEX.BrightGray};
  }
`;

MenuItem.Icon = styled.img`
  height: 18px;
  width: 18px;
  margin-right: 14px;
  object-fit: contain;
`;
export const PaymentCardIcon = styled(PaymentCard)`
  color: ${ColorPalette.HEX.ChineseSilver2};
  height: 18px;
  width: 18px;
  margin-right: 14px;
`;

MenuItem.Title = styled.span`
  line-height: 1.43;
  font-size: 14px;
  font-weight: normal;
  color: ${({ theme }) => theme.group.subTitle};
`;

export const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.listPreviewCard.white};
  box-shadow: 0 4px 10px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);
  margin: 10px;

  & ${MenuItem}:last-child {
    border-bottom: none;
  }
`;
